<template>
  <div id="app" :class="isHui ? 'gray-mode' : ''">
    <div v-if="isVersion">
      <router-view></router-view>
    </div>
    <div class="version-info bg1" v-else v-cloak>
      <div class="title-web">
        <i class="icon-close content-icon" @click="gotoInfo()"></i>
      </div>
      <div class="content-info">
        <div class="content-info-img"></div>
        <div class="content-info-text">
          大智慧因子量化投研功能开启Beta版试用了，目前功能在飞快迭代中，暂未对所有用户开放，如有疑问请点击下方按钮联系客服人员进行咨询。
        </div>
        <div class="content-info-button" @click="gotoKefu()">联系客服</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserToDay, getClientRedis } from '@/api/index.js';
import mixins from '@/mixins/index.js';
export default {
  mixins: [mixins],
  data() {
    return {
      isHui: window.config.GRAY_MODE,
      themeStyleVs: 1,
      isVersion: true
    };
  },
  created() {
    this.$store.dispatch('checkVipStatus');

    if (window.config.isWeb == true) {
      if (typeof DzhAppJs == 'undefined') {
        // 外部
        this.isVersion = false;
      }
    }

    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    if (this.themeStyleVs === 2) {
      document.querySelector('html').style.background = '#0C0F13';
      document.querySelector('body').setAttribute('style', 'background-color:#0C0F13;');
      document.querySelector('#app').setAttribute('style', 'background-color:#0C0F13;');
    }
    // this.getUserDate();
    // this.getPropData();
  },
  methods: {
    getPropData: function () {
      let that = this;
      // console.log(that.$route.name);
      // if (that.$route.name === 'Home') return;
      getClientRedis({})
        .then((res) => {
          // console.log("getClientRedis")
          if (res.err === 200) {
            let data = JSON.parse(res.data);
            that.setLocalData(data);
          } else {
            that.setLocalData();
          }
        })
        .catch(() => {
          that.setLocalData();
        });
    },
    gotoInfo: function () {
      window.location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    // 联系客服
    gotoKefu: function () {
      window.location.href =
        'dzh_browser_url&goto=0&screen=234&dzh_account=dzhkf80101&tim_identifer=dzhkf80101&action=1';
    }
  }
};
</script>

<style lang="less" scoped>
.gray-mode {
  filter: grayscale(0.95);
  -webkit-filter: grayscale(0.95);
}
</style>
<style lang="less">
@import './assets/css/public.less';
</style>
